<template>
  <chip
    class="number-chip"
  >
    <span class="number">{{value}}</span>
    <span class="label">{{label}}</span>
  </chip>
</template>

<script>
  import Chip from '@/components/common/Chip';

  export default {
    props: ['value', 'label'],
    components: {
      Chip,
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../scss/_colors.scss";

  .number-chip {
    justify-self: flex-end;
    &, &:active, &:focus, &:hover {
      padding: 8px 16px;
    }

      &::v-deep > span {
        align-items: center;
        display: flex;
      }

    .number {
      font-size: 12px;
      border-radius: 100%;
      background-color: $purple;
      color: $white;
      width: 26px;
      height: 26px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      transition: background 0.2s, font-weight 0.2s ;
    }

    .label {
      margin-left: 8px;
      text-transform: capitalize;
    }

    &:hover .number {
      background-color: $white;
      color: $purple;
    }
  }
</style>
